import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PAYMENT_INFO_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetPaymentServiceStatusPayload,
  GetPaymentServiceStatusResult,
  PaymentStatusInfo,
} from '../types/getPaymentInfo.types';

export const PAYMENT_SERVICE_STATUS = 'PaymentServiceStatus';
export const getPaymentServiceStatus = (builder: BuilderType) =>
  builder.query<PaymentStatusInfo, GetPaymentServiceStatusPayload>({
    providesTags: [PAYMENT_SERVICE_STATUS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PAYMENT_INFO_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetPaymentServiceStatusResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.PaymentInfo;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
